import { Component, Input } from '@angular/core';
import { CalendarEvent } from 'calendar-utils';

@Component({
  selector: 'mwl-calendar-event-actions',
  template: `
    <span *ngIf="event.actions" class="cal-event-actions">
      <a
        class="cal-event-action"
        href="javascript:;"
        *ngFor="let action of event.actions"
        (click)="action.onClick({event: event})"
        [ngClass]="action.cssClass">
        <md-icon>{{ action.label }}</md-icon>
      </a>
    </span>
  `
})
export class CalendarEventActionsComponent {

  @Input() event: CalendarEvent;

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/components/common/calendarEventActions.component.ts